export default "__VITE_ASSET__2F0O86bd__"